import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import MaintenanceView from './components/views/MaintenanceView';
import reportWebVitals from './reportWebVitals';

initializeFaro({
  url: 'https://faro-collector-prod-sa-east-1.grafana.net/collect/e2726fc2ff2340fa483ec46dda8285db',
  app: {
    name: 'assinaturas_equatorial',
    version: '1.0.0',
    environment: 'production'
  },
  
  instrumentations: [
    ...getWebInstrumentations(),
    new TracingInstrumentation(),
  ],
});

// Modo manutenção: site fora do ar. Troque para false para voltar ao normal.
const MAINTENANCE_MODE = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {MAINTENANCE_MODE ? <MaintenanceView /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();